export const AppConfigs = {
  apiBaseUrl: "https://jsonplaceholder.typicode.com",
};
